export const winners2024 = [
  {
    id: '2024-1',
    name: 'Precision Forestry',
    organization: 'APP Forestry',
    pillar: 'Pulp & Paper',
    orgUnit: '',
    title: '',
    teamMembers: [],
    description: '',
    image: '',
    award: 'Digital Transformation Champion',
    year: 2024,
    category: '',
    linkedIn: '#',
    projectLink: '#',
    details: ``,
  },
  {
    id: '2024-2',
    name: 'Precision Forestry',
    organization: 'APP Forestry',
    pillar: 'Pulp & Paper',
    orgUnit: '',
    title: '',
    teamMembers: [],
    description: '',
    image: '',
    award: 'Innovation Excellence',
    year: 2024,
    category: '',
    linkedIn: '#',
    projectLink: '#',
    details: ``,
  },
  {
    id: '2024-3',
    name: 'SmartTrace',
    organization: 'GAR',
    pillar: 'Agri-business & Food',
    orgUnit: '',
    title: '',
    teamMembers: [],
    description: '',
    image: '',
    award: 'Sustainable Solution',
    year: 2024,
    category: '',
    linkedIn: '#',
    projectLink: '#',
    details: ``,
  },
  {
    id: '2024-4',
    name: 'New SimobiPlus',
    organization: 'SQE',
    pillar: 'SMMA',
    orgUnit: '',
    title: '',
    teamMembers: [],
    description: '',
    image: '',
    award: 'Best Collaborative Project',
    year: 2024,
    category: '',
    linkedIn: '#',
    projectLink: '#',
    details: ``,
  },
  {
    id: '2024-5',
    name: 'Angkoso Brami Prasojo',
    organization: 'APP',
    pillar: 'Pulp & Paper',
    orgUnit: '',
    title: '',
    teamMembers: [],
    description: '',
    image: '',
    award: 'Young Digital Leaders',
    year: 2024,
    category: '',
    linkedIn: '#',
    projectLink: '#',
    details: ``,
  },
];
